import mechanic from "../assets/icons/mechanic.png";
import gear from "../assets/icons/gear.png";
import expense from "../assets/icons/expense.png";
import sold from "../assets/icons/sold.png";
import dollarSign from "../assets/icons/dollar-sign.png";

export const financeCategoryList = [
  { img: gear, name: "Part" },
  { img: mechanic, name: "Master" },
  { img: expense, name: "Other" },
];

export const financeIcon = (name) =>
  ({
    Part: gear,
    Master: mechanic,
    Other: expense,
    Sold: sold,
    General: dollarSign,
  }[name]);
